import gql from 'graphql-tag';

export const updateEscalationRule = gql`
  mutation updateEscalationRule($escalationRule: InputUpdateEscalationRule!) {
    updateEscalationRule(escalationRule: $escalationRule)
  }
`;
